import React, { useState, useEffect } from "react";

export default function DisplayPrice({ product, variant, showPriceFrom }) {
  const [from, setFrom] = useState("");
  const [strikeThroughPrice, setStrikeThroughPrice] = useState(null);
  const [price, setPrice] = useState(` $${variant.price}`);

  useEffect(() => {
    const fromCheck =
      product.priceRangeV2.maxVariantPrice.amount !==
      product.priceRangeV2.minVariantPrice.amount;
    if (variant.compareAtPrice) {
      // If a strikethrough price should be shown
      setFrom(
        fromCheck &&
          variant.price === product.priceRangeV2.minVariantPrice.amount
          ? "From "
          : ""
      );
      setStrikeThroughPrice(`$${variant.compareAtPrice}`);
    } else if (fromCheck) {
      // If there are more expensive variants, 'From ' should be shown
      setFrom(
        variant.price === product.priceRangeV2.minVariantPrice.amount
          ? "From "
          : ""
      );
    }
    setPrice(` $${variant.price}`);
  }, [variant]);

  return (
    <p className="mt-1 md:mt-2 w-full text-lg">
      {showPriceFrom && from}
      {strikeThroughPrice && <del>{strikeThroughPrice}</del>}
      {price}
    </p>
  );
}
